import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import i18n from 'i18n';
import { FaultType } from 'types/rest/dslTypes';
import { TransactionType } from 'types/rest/assetCatalogTypes';
import BlazeInputDropdown, { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';

export const FAULT_OPTIONS: { value: FaultType | ''; label: string; description: string }[] = [
  { value: '', label: i18n.t('transactions:faults.noneOption'), description: '' },
  {
    value: 'EMPTY_RESPONSE',
    label: i18n.t('transactions:faults.EMPTY_RESPONSE'),
    description: i18n.t('transactions:faults.EMPTY_RESPONSE_desc'),
  },
  {
    value: 'RANDOM_DATA_THEN_CLOSE',
    label: i18n.t('transactions:faults.RANDOM_DATA_THEN_CLOSE'),
    description: i18n.t('transactions:faults.RANDOM_DATA_THEN_CLOSE_desc'),
  },
  {
    value: 'MALFORMED_RESPONSE_CHUNK',
    label: i18n.t('transactions:faults.MALFORMED_RESPONSE_CHUNK'),
    description: i18n.t('transactions:faults.MALFORMED_RESPONSE_CHUNK_desc'),
  },
  {
    value: 'CONNECTION_RESET_BY_PEER',
    label: i18n.t('transactions:faults.CONNECTION_RESET_BY_PEER'),
    description: i18n.t('transactions:faults.CONNECTION_RESET_BY_PEER_desc'),
  },
];

const defaultFaultOption: BlazeDropdownItem = {
  id: '',
  name: i18n.t('transactions:faults.noneOption'),
};

const faultDropdownItems: BlazeDropdownItem[] = FAULT_OPTIONS.filter(opt => opt.value !== '').map(opt => ({
  id: opt.value,
  name: opt.label,
}));

interface FaultTabProps {
  fault?: FaultType;
  type: TransactionType;
  isReadOnly?: boolean;
  onFaultChanged: (fault: FaultType | undefined) => void;
}

const FaultTab = (props: FaultTabProps) => {
  if (props.type === 'MESSAGING') {
    return null;
  }

  const selectedValue = props.fault ?? '';

  const selectedOption = FAULT_OPTIONS.find(opt => opt.value === selectedValue);
  const selectedDescription = selectedOption ? selectedOption.description : '';

  const handleDropdownClick = (item: BlazeDropdownItem) => {
    const value = item.id as FaultType | '';
    props.onFaultChanged(value === '' ? undefined : value);
  };

  const selectedDropdownItem: BlazeDropdownItem =
    selectedValue === '' ? defaultFaultOption : { id: selectedValue, name: selectedOption?.label ?? selectedValue };

  return (
    <div>
      <Row>
        <Col md={8}>
          <p className="mb-3">{i18n.t('transactions:faults.description')}</p>
        </Col>
      </Row>
      <div style={{ width: '290px' }}>
        <Form.Group controlId="faultSimulationSelect">
          <Form.Label>{i18n.t('transactions:faults.label')}</Form.Label>
          <BlazeInputDropdown
            id="qa-select-fault-simulation"
            showGroups={false}
            isSearchable={false}
            items={faultDropdownItems}
            selected={selectedDropdownItem}
            onClick={handleDropdownClick}
            isDefaultOptionSelectable={true}
            defaultOption={defaultFaultOption}
            disabled={props.isReadOnly}
          />
          {selectedDescription && <Form.Text className="text-muted mt-2">{selectedDescription}</Form.Text>}
        </Form.Group>
      </div>
    </div>
  );
};

export default FaultTab;
